import { FC, useCallback, useState } from 'react'
import { copyTextToClipboard, IconButton, TextButton, toast } from 'react-common'
import { useTranslation } from 'react-i18next'
import { Tooltip2 } from '@platform/ui'
import { useIsMobile } from '@/hooks/useIsMobile'
import { useGenerateCourseLink } from './useGenerateCourseLink'
import { ButtonContainer } from '../ButtonContainer/ButtonContainer'

type ShareButtonProps = {
  isOpenCatalog?: boolean
}

export const ShareButton: FC<ShareButtonProps> = ({ isOpenCatalog }) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const [isCopied, setIsCopied] = useState(false)
  const link = useGenerateCourseLink({ isOpenCatalog })

  const copyLink = useCallback(async () => {
    await copyTextToClipboard(link)
    setIsCopied(true)

    toast.success(t('courseDetails.shareButton.copiedText'))

    setTimeout(() => setIsCopied(false), 10 * 1000)
  }, [link, t])

  return (
    <ButtonContainer>
      {isMobile ? (
        <TextButton
          aria-label="share course button"
          data-qa="share-course-button"
          leftIcon={isCopied ? 'CheckBoldStroke' : 'ShareAppleBoldStroke'}
          size="large"
          variant="secondary"
          onClick={copyLink}
        >
          {isCopied ? t('courseDetails.shareButton.copiedText') : t('courseDetails.shareButton.text')}
        </TextButton>
      ) : (
        <Tooltip2 content={t('courseDetails.shareButton.text')} position="right">
          <IconButton
            aria-label="share course button"
            data-qa="share-course-button"
            icon={isCopied ? 'CheckBoldStroke' : 'ShareAppleBoldStroke'}
            size="large"
            variant="secondary"
            onClick={copyLink}
          />
        </Tooltip2>
      )}
    </ButtonContainer>
  )
}
